import Joi from "joi-browser";

const schemas = {
  get_started: {
    first_name: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your name is required"
        };
      }),
    second_name: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your name is required"
        };
      }),
    date: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your wedding date is required"
        };
      }),
    location: Joi.string()
      .max(50)
      .allow("")
      .error(() => {
        return {
          message: "Your wedding location must be a string"
        };
      })
  },
  billing_address: {
    card_name: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your name is required"
        };
      }),
    street_address: Joi.string()
      .min(2)
      .max(255)
      .required()
      .error(() => {
        return {
          message: "Your street address is required"
        };
      }),
    city: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your city is required"
        };
      }),
    state: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your province/state is required"
        };
      }),
    zip_code: Joi.string()
      .min(2)
      .max(15)
      .required()
      .error(() => {
        return {
          message: "Your postal/zip code is required"
        };
      }),
    country: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your country is required"
        };
      })
  },
  payment_details: {
    card_name: Joi.string()
      .min(2)
      .max(255)
      .required()
      .error(() => {
        return {
          message: "Your name is required"
        };
      }),
    email: Joi.string()
      .email()
      .required()
      .error(() => {
        return {
          message: "Your email is required"
        };
      })
  },
  sender_information: {
    card_name: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your name is required"
        };
      }),
    street_address: Joi.string()
      .min(2)
      .max(255)
      .required()
      .error(() => {
        return {
          message: "Your street address is required"
        };
      }),
    city: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your city is required"
        };
      }),
    state: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your province/state is required"
        };
      }),
    zip_code: Joi.string()
      .min(2)
      .max(15)
      .required()
      .error(() => {
        return {
          message: "Your postal/zip code is required"
        };
      }),
    country: Joi.string()
      .min(2)
      .max(50)
      .required()
      .error(() => {
        return {
          message: "Your country is required"
        };
      })
  }
};

export const validate = (data, schema) => {
  const options = { abortEarly: false, allowUnknown: true };
  const { error } = Joi.validate(data, schemas[schema], options);
  if (!error) return null;

  const errors = {};
  for (let item of error.details) errors[item.path[0]] = item.message;
  return errors;
};

export const validateProperty = ({ name, value }, schema) => {
  const obj = { [name]: value };
  const individualSchema = { [name]: schemas[schema][name] };
  const { error } = Joi.validate(obj, individualSchema);
  return error ? error.details[0].message : null;
};
